import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { errMsg } from './errors';

/**
 * A failed list/detail fetch, said plainly, with a Retry. Shown INSTEAD of an
 * empty table: an empty table after a failure reads as "there is nothing here",
 * which sends the admin hunting for data that exists.
 */
export function QueryError({
  error,
  what,
  onRetry,
  style,
}: {
  error: unknown;
  /** What was being loaded, e.g. "recharge history". */
  what: string;
  onRetry?: () => void;
  style?: React.CSSProperties;
}) {
  return (
    <Alert
      type="error"
      showIcon
      data-testid="query-error"
      message={`Unable to load ${what}`}
      description={errMsg(error, 'Try again in a moment.')}
      style={style}
      action={
        onRetry ? (
          <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
            Retry
          </Button>
        ) : undefined
      }
    />
  );
}
